import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/shared/dialogs/models';

@Component({
  templateUrl: './delete-company-admin-dialog.component.html',
  styleUrls: ['./delete-company-admin-dialog.component.scss'],
})
export class DeleteCompanyAdminDialogComponent {
  constructor(private dialogRef: MatDialogRef<DeleteCompanyAdminDialogComponent, DialogResult>) {}

  public close(): void {
    this.dialogRef.close({ done: false });
  }

  public done(): void {
    this.dialogRef.close({ done: true });
  }
}
